import React from 'react';

function PageHeader( props ) {
    const { title, subTitle, icon=null } = props;

    return (
        <div className="page-header text-center" >
            <div className="container">
                <h1 className="page-title">{ title } {icon && <i className={icon}></i>}<span>{ subTitle }</span></h1>
            </div>
        </div>
    );
}

export default React.memo( PageHeader );